// @flow weak

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

/*
   Render 'Loading...' screen. If the showMessage prop is false,
   renders without the 'Loading...' text.
*/
const LoadingScreen = createReactClass({
  displayName: 'LoadingScreen',
  mixins: [PureRenderMixin],

  propTypes: {
    showMessage: PropTypes.bool,
  },

  render: function() {
    return (
      <div className="table-wrapper fill" key="loading-spinner">
        <div className="spinner" />
        {this.message()}
      </div>
    );
  },

  message: function() {
    if (this.props.showMessage !== false) {
      return <h3 className="spinner-text center">Loading...</h3>;
    }
    return '';
  },
});

export default LoadingScreen;
